import React from "react";
import classes from "./FilterBar.module.css";
import { Autocomplete, TextField } from "@mui/material";

const FilterBar = ({ onFilterChange, filterValue, customClass }) => {
  const options = [
    { value: "", label: "All" },
    { value: "waitingForApproval", label: "Waiting for approval" },
    { value: "Approved", label: "Approved" },
    { value: "Cancelled", label: "Cancelled" },
  ];

  return (
    <div className={`${classes.filter_wrapper} ${customClass} flex`}>
      <Autocomplete
        sx={{
          minHeight: "4.2rem",
          width: "100%",
          height: "auto",
          fontSize: "4rem",
          transition: "0",
          ".Mui-expanded": {
            transition: "none",
          },
          ".MuiOutlinedInput-notchedOutline": {
            border: "0",
          },
          ".MuiAutocomplete-input": {
            fontSize: "1.4rem",
            fontFamily: "GilroyMedium",
            height: "2.6rem",
          },
          ".MuiFormLabel-root": {
            display: "none",
          },
          ".MuiChip-root": {
            height: "30px",
            padding: "5px",
          },
        }}
        size="medium"
        options={options}
        getOptionLabel={(option) => option.label}
        value={options.find((option) => option.value === filterValue) || null}
        onChange={(event, newValue) =>
          onFilterChange(newValue ? newValue.value : "")
        }
        renderInput={(params) => (
          <TextField {...params} label="Filter" variant="outlined" />
        )}
      />
    </div>
  );
};

export default FilterBar;
